import { z } from "zod";

// Esquema para o Termo de Responsabilidade
const termoSchema = z.object({
  nomeCompleto: z.string().min(1, { message: "O nome completo é obrigatório!" }).min(3, {
    message: "O nome completo deve ter pelo menos 3 caracteres!",
  }),
  cpf: z
    .string()
    .min(1, { message: "O CPF é obrigatório!" })
    .regex(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, {
      message: "CPF inválido, formato esperado: 000.000.000-00!",
    }),
});

// Exportando o esquema para validação
export { termoSchema };
